import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ReadProject } from "@/types/project";
import { useProjectActions } from "../hooks/useProjectActions";
import ProjectConfirmDialog from "./ProjectConfirmDialog";

interface ProjectRestoreConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  projectId: string;
  project?: ReadProject;
}

const ProjectRestoreConfirmDialog = ({
  open,
  onOpenChange,
  projectId,
  project,
}: ProjectRestoreConfirmDialogProps) => {
  const { t } = useTranslation();
  const { restore } = useProjectActions(projectId, project);

  const confirmAction = useCallback(
    () => restore.mutateAsync(undefined),
    [restore],
  );

  return (
    <ProjectConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("projects.actions.restore.confirm.title")}
      description={t("projects.actions.restore.confirm.content")}
      cancelLabel={t("common.cancel")}
      confirmLabel={t("projects.actions.restore.title")}
      confirmAction={confirmAction}
      confirmButtonVariant="default"
      isPending={restore.isPending}
    />
  );
};

export default ProjectRestoreConfirmDialog;
